export const isEventLive = (eventStart: string, eventEnd: string) => {
  return new Date().getTime() >= new Date(eventStart).getTime() && new Date().getTime() <= new Date(eventEnd).getTime();
};
